import React, { useState } from 'react';
import axios from 'axios';
import { BiLogIn, BiUserPlus } from 'react-icons/bi';
import { IoClose } from 'react-icons/io5';
import { useAppContext } from './AppContext';
import LoadingElement from './loadingElement';
import Notification from './Notification';
import Lottie from 'lottie-react';
import animationData from '../assets/animation-1.json'; // Replace with the path to your Lottie JSON file
import animationData2 from '../assets/website-building-of-shopping-sale.json'
import jsAnimation from '../assets/java-script.json'
import DocAnimation from '../assets/singing-contract.json'
const WelcomePage = () => {
  const {   username, setUsername } = useAppContext();
  // const [scrolled, setScrolled] = useState('')
  const {  setLoggedIn } = useAppContext();
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [isUsernameUnique, setIsUsernameUnique] = useState(true);
  const [passwordStrength, setPasswordStrength] = useState('');
  const [isloading, setisloading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [notification, setNotification] = useState(null);
  const token = localStorage.getItem('token');





  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 3000); // Automatically hide notification after 3 seconds
  };


  const handleCloseNotification = () => {
    setNotification(null);
  };


 
  const handleLogin = () => {
    setFormType('login');
    setErrorMessage('');
    setShowForm(true);
  };

  const handleSignup = () => {
    setFormType('signup');
    setErrorMessage('')
    setShowForm(true);
    
  };

  const handleUsernameChange = async (e) => {
    const newUsername = e.target.value;
    setUsername(newUsername);

    try {
      const response = await axios.post('https://my-first-website-production.up.railway.app/check-username', { username: newUsername },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      setIsUsernameUnique(response.data.isUnique);
    } catch (error) {
      console.error('Error checking username:', error);
    }
  };
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setPasswordStrength(checkPasswordStrength(newPassword));
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const checkPasswordStrength = (password) => {
    if (password.length > 0) {
      if (password.length < 8) return 'Too short';
      if (!/[A-Z]/.test(password)) return 'Add uppercase letter';
      if (!/[a-z]/.test(password)) return 'Add lowercase letter';
      if (!/[0-9]/.test(password)) return 'Add number';
      if (!/[!@#$%^&*()_+]/.test(password)) return 'Add special character';
      return 'wow that is Strong';
    }
  };

  const handleSignupLogic = async () => {


    if (password !== confirmPassword) {
      // alert('Passwords do not match');
      showNotification('Passwords do not match ')
      return;
    }
    setisloading(true);
    setShowForm(false);
    const userData = {
      username,
      email,
      password,
    };

    try {

      const response = await axios.post('https://my-first-website-production.up.railway.app/signup', userData, {
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': `Bearer ${token}`
        },
        withCredentials: true,
      });

      if (response.data.message === 'Signup successful! A verification code has been sent to your email.') {
        showNotification('Sign up successful! A verification code has been sent to your email.')
        // alert('Sign up successful! A verification code has been sent to your email.');
        setShowForm(true);
        setFormType('verify-email');

      } else {
        setShowForm(true);
        setErrorMessage('Error during sign up: ' + response.data.message);
        // alert('Error during sign up: ' + response.data.message);
        showNotification('Error during sign up: ' + response.data.message)

      }
      setisloading(false);
    } catch (error) {
      console.error('Error during sign up:', error);
      showNotification('Error during sign up: ' + error);

      setErrorMessage('An error occurred during sign up. Please try again later.');
      setisloading(false);
      setShowForm(true);
    }
  };

  const handleVerifyEmail = async () => {
    setShowForm(false);
    setisloading(true);

    try {
      const response = await axios.post('https://my-first-website-production.up.railway.app/verify-email', { email, verificationCode }, {
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': `Bearer ${token}`
        },
        withCredentials: true,
      });

      if (response.data.message === 'Email verified successfully') {
        // alert('Email verified successfully');
        showNotification('Email verified successfully now login in')
        setFormType('login');
        setShowForm(true);
      } else {
        setShowForm(true);
        showNotification('Error during email verification: ' + response.data.message)
        setErrorMessage('Error during email verification: ' + response.data.message);
      }
      setisloading(false);
    } catch (error) {
      console.error('Error verifying email:', error);
      setErrorMessage('An error occurred during email verification. Please try again later.');
      setisloading(false);
      setShowForm(true);
    }
  };

  const handleLoginLogic = async () => {

    setisloading(true);
    setShowForm(false);

    try {

      const response = await axios.post('https://my-first-website-production.up.railway.app/login', { username, password }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        withCredentials: true // This is equivalent to 'credentials: include' in fetch
      });

      if (response.data.message === 'Login successful') {
        setLoggedIn(true);
        setShowForm(false);
        setUsername(username); // Set the username in the context
        // alert('Login successful');
        showNotification('Login successful')
        const { token } = response.data; // Assume token is in response.data

        if (token) {
          localStorage.setItem('token', token);
          localStorage.setItem('username', username); // Store username in local storage
          // Redirect or update state as necessary
        } else {
          console.error('No token received');
        }
      } else {
        setShowForm(true);
        showNotification('Error during login: ' + response.data.message)


        setErrorMessage('Error during login: ' + response.data.message);
      }
      setisloading(false);
    } catch (error) {
      console.error('Error during login:', error);
      setErrorMessage('An error occurred during login. Please try again later.');
      showNotification('Error during login: ' + error)
      setisloading(false);
      setShowForm(true);

    }
  };


  return (
    <>
      <LoadingElement display={isloading ? "block" : "hidden"} />
      {notification && (
        <Notification
          message={notification}
          onClose={handleCloseNotification}
        />
      )}
                <div
                  className={`relative showAnimation min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-purple-600 via-sky-600 to-blue-900 dark:from-gray-600 dark:via-gray-900 dark:to-black text-white overflow-hidden duration-500`}
                >
   
            <div className="absolute  top-0 left-0 w-full h-full overflow-hidden z-10">
          <div className="diamond"></div>
          <div className="diamond diamond-2"></div>
          <div className="diamond diamond-3"></div>
          <div className="diamond diamond-4"></div>
          <div className="diamond diamond-5"></div>
          <div className="diamond diamond-6 "></div>
        </div>
        {/* login section */}
        <h1 className="text-3xl w-full pb-4 neon-text border-b-2 sm:text-6xl text-pretty text-center font-bold mb-6 z-20">Welcome to Our Website</h1>
        <p className="text-2xl  sm:text-4xl text-pretty text-center mb-6 z-20">Experience the best service with us</p>
        <h3 className='p-2 text-2xl text-center mb-4'> please make an acount or login so that you can test our backend server which support authentication ,mangoDb , file uploading and a lot more </h3>
        <div className="flex pb-12   space-x-4 z-20">
          <button
            onClick={handleLogin}
            className="flex  items-center space-x-2 p-4 bg-inherit border-white border-4 text-white rounded-lg shadow-md dark:bg-gray-700 dark:text-white hover:-translate-y-1 transition-all duration-1000"
          >
            <BiLogIn className="text-2xl " />
            <span >Login</span>
          </button>
          <button
            onClick={handleSignup}
            className="flex  items-center space-x-2 p-4 bg-inherit border-white border-4 text-white rounded-lg shadow-md dark:bg-gray-700 dark:text-white hover:-translate-y-1 transition-all duration-1000"
          >
            <BiUserPlus className="text-2xl " />
            <span>Sign Up</span>
          </button>
        </div>

        <div className='w-full'>
  <h1 className='text-3xl neon-text border-b-2 pb-4 sm:text-6xl text-pretty text-center font-bold z-20'>Full-Stack Web Designer</h1>
</div>

<div className='w-full'>
  <h1 className='text-xl mt-2 sm:text-2xl text-pretty text-left font-bold pl-2 z-20'>What makes us unique?</h1>
</div>

<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full h-full z-10">
  {/* Frontend Section */}
  <div className="flex flex-col justify-center items-center showAnimation">
    <Lottie
      className='floatAnimation'
      animationData={animationData}
      loop={false}
      autoplay={false}
      style={{ width: '94%', maxWidth: '350px', animationDelay: '0ms' }}
    />
    <h3 className="text-center text-xl p-2 mt-2 md:-mt-2 md:text-base">Organized Layout With Modern UI To Satisfy Your Clients</h3>
  </div>

  <div className="flex flex-col justify-center items-center">
    <Lottie
      className='floatAnimation'
      animationData={animationData2}
      loop={false}
      autoplay={false}
      style={{ width: '94%', maxWidth: '350px', animationDelay: '500ms' }}
    />
    <h3 className="text-center p-2 mt-2 md:-mt-2 text-xl md:text-base">Customized website designs as I believe that each website should be unique</h3>
  </div>

  <div className="flex flex-col justify-center items-center">
    <Lottie
      className='floatAnimation'
      animationData={jsAnimation}
      loop={false}
      autoplay={false}
      style={{ width: '94%', maxWidth: '350px', animationDelay: '1000ms' }}
    />
    <h3 className="text-center mt-2 p-2 md:-mt-2 text-xl md:text-base">We use the latest Technologies to build our web apps to make it scalable, responsive, and optimized as much as possible</h3>
  </div>

  <div className="flex flex-col justify-center items-center">
    <Lottie
      className='floatAnimation'
      animationData={DocAnimation}
      loop={false}
      autoplay={false}
      style={{ width: '94%', maxWidth: '350px', animationDelay: '1500ms' }}
    />
    <h3 className="text-center mt-2 p-2 md:-mt-2 text-xl md:text-base">Your project will be documented and all files will be organized to make it easy for you to redesign your website easily</h3>
  </div>

  {/* Backend Section */}
  <div className="flex flex-col justify-center items-center">
    <img
      src="/undraw_male_avatar_g98d.svg"
      alt="profile make"
      className="floatAnimation"
      style={{ width: '90%', maxWidth: '300px', marginBottom:'50px',height: '200px', animationDelay: '0ms' }}
    />
    <h3 className="text-center text-xl p-2 mt-2 md:-mt-2 md:text-base">Make your own profile easily</h3>
  </div>

  <div className="flex flex-col justify-center items-center">
    <img
      src="/undraw_fingerprint_login_re_t71l.svg"
      alt="authentication required to access data"
      className="floatAnimation"
      style={{ width: '90%', maxWidth: '300px', marginBottom:'50px',height: '200px', animationDelay: '500ms' }}
    />
    <h3 className="text-center p-2 mt-2 md:-mt-2 text-xl md:text-base">Authentication JWT to authenticate before accessing any part of our server</h3>
  </div>

  <div className="flex flex-col justify-center items-center">
    <img
      src="/undraw_security_re_a2rk.svg"
      alt="security"
      className="floatAnimation"
      style={{ width: '90%', maxWidth: '300px', marginBottom:'50px',height: '200px', animationDelay: '1000ms' }}
    />
    <h3 className="text-center mt-2 p-2 md:-mt-2 text-xl md:text-base">Depending on your role (admin, user, or developer) you can access specific parts and functionality</h3>
  </div>

  <div className="flex flex-col justify-center items-center">
    <img
      src="/undraw_add_information_j2wg.svg"
      alt="add information"
      className="floatAnimation"
      style={{ width: '90%', maxWidth: '300px', marginBottom:'50px',height: '200px', animationDelay: '1500ms' }}
    />
    <h3 className="text-center mt-2 p-2 md:-mt-2 text-xl md:text-base">Easily get updates or add new info into the database</h3>
  </div>
</div>


        

      </div>
      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center transition-opacity duration-500 z-30">
        


          <div className="relative bg-white bg-opacity-45 dark:bg-opacity-45 backdrop-blur-md dark:bg-gray-800 p-6 rounded-lg shadow-lg sm:w-96 w-4/5 z-50 transform transition-transform duration-500 scale-95 neon-border">


            <button
              className="absolute top-2 right-2 text-black border-2 border-black  rounded-full p-1 focus:outline-none dark:text-white dark:border-white"
              onClick={() => {
                setShowForm(false);  // Hide the form
                
              }}
            >
              <IoClose className='text-2xl' />
            </button>


            {formType === 'login' ? (
              <div className='login'>
                <h2 className="text-2xl  mb-8 text-center text-white neon-text">Login</h2>
                <div className='relative'>
                  <input
                    type="text"
                    placeholder=''
                    required
                    spellCheck={false}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="block  w-full mb-6 p-2 border-2 border-gray-300 dark:border-gray-600 rounded bg-transparent outline-none  text-black dark:text-white"
                  />
                  <label className='absolute top-1/2 text-white  transition-all pointer-events-none duration-300 -translate-y-1/2 left-2'  >Enter your username</label>
                </div>
                <div className='relative mt-9'>
                  <input
                    required
                    spellCheck={false}
                    placeholder=''
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="block  w-full mb-6 p-2 border-2 border-gray-300 dark:border-gray-600 rounded bg-transparent outline-none  text-black dark:text-white"
                  />
                  <label className='absolute text-white transition-all pointer-events-none duration-300 top-1/2 -translate-y-1/2 left-2'  >Enter your password</label>
                </div>
                <button onClick={handleLoginLogic} className="w-full p-2 bg-blue-500 dark:bg-blue-700 text-white rounded">Login</button>
                <p className="mt-4 text-center">
                  Don't have an account?
                  <button onClick={() => { setFormType('signup'); setErrorMessage(''); }} className="text-green-400 ml-1 dark:text-blue-300">
                    Sign Up
                  </button>
                </p>
                {errorMessage && <p className="mb-4 text-red-500 dark:text-red-400 text-center">{errorMessage}</p>}
              </div>
            ) : formType === 'signup' ? (
              <div className='login'>
                <h2 className="text-2xl mb-8 text-white text-center neon-text">Signup</h2>
                <div className='relative mb-8'>
                  <input
                    required
                    spellCheck={false}
                    placeholder=''
                    type="text"
                    value={username}
                    onChange={handleUsernameChange}
                    className="block  w-full mb-6 p-2 border-2 border-gray-300 dark:border-gray-600 rounded bg-transparent outline-none  text-black dark:text-white"
                  />
                  <label className='absolute text-white transition-all pointer-events-none duration-300 top-1/2 -translate-y-1/2 left-2'  >Enter your Username</label>

                  {!isUsernameUnique && <p className="text-red-500 -mt-6 dark:text-red-400">Username is already taken</p>}
                </div>
                <div className='relative mb-8'>
                  <input
                    required
                    spellCheck={false}
                    type="email"
                    value={email}
                    placeholder=''
                    onChange={(e) => setEmail(e.target.value)}
                    className="block w-full mb-6 p-2 border-2 border-gray-300 dark:border-gray-600 rounded bg-transparent outline-none  text-black dark:text-white"
                  />
                  <label className='absolute text-white transition-all pointer-events-none duration-300 top-1/2 -translate-y-1/2 left-2'  >Enter your Email</label>

                </div>
                <div className='relative mb-8'>
                  <input
                    required
                    spellCheck={false}
                    placeholder=''
                    type="password"
                    value={password}
                    onChange={handlePasswordChange}
                    className="block  w-full mb-6 p-2 border-2 border-gray-300 dark:border-gray-600 rounded bg-transparent outline-none  text-black dark:text-white"
                  />
                  <label className='absolute text-white transition-all pointer-events-none duration-300 top-1/2 -translate-y-1/2 left-2'  >Enter your password</label>
                  <p className="text-center ">{passwordStrength}</p>

                </div>
                <div className='relative mb-8'>
                  <input
                    required
                    spellCheck={false}
                    placeholder=''
                    type="password"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    className="block  w-full mb-6 p-2 border-2 border-gray-300 dark:border-gray-600 rounded bg-transparent outline-none  text-black dark:text-white"
                  />
                  <label className='absolute text-white transition-all pointer-events-none duration-300 top-1/2 -translate-y-1/2 left-2'  >confirm your password </label>

                </div>
                <button onClick={handleSignupLogic} className="w-full p-2 bg-blue-500 dark:bg-blue-700 text-white rounded">Sign Up</button>
                <p className="mt-4 text-center">Already have an account? <button onClick={() => { setFormType('login'); setErrorMessage(''); }} className="text-green-400 dark:text-blue-300">Login</button></p>
                {errorMessage && <p className="mb-4 text-red-500 dark:text-red-400 text-center">{errorMessage}</p>}

              </div>
            ) : (
              <div >
                <h2 className="text-2xl font-bold mb-4 text-blue-500 dark:text-blue-300">Verify Email</h2>
                <input
                  type="text"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  placeholder="Verification Code"
                  className="block w-full mb-4 p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-900 text-black dark:text-white"
                />
                <button onClick={handleVerifyEmail} className="w-full p-2 bg-blue-500 dark:bg-blue-700 text-white rounded">Verify Email</button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
export default WelcomePage;
